import axios from '../utils/axios';

export default function fetchPotentialPaidJobsCount(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/potential-paid-jobs-count', {
            params: params
        })
    )
}
